import { createStore, applyMiddleware, AnyAction } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk, { ThunkDispatch } from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import rootReducer from "../reducers/root.reducer";

const middleware = [thunk];
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['dashboard','propertyDetails','userScreens'] 
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware)),
);
const persistor = persistStore(store);

type RootState = ReturnType<typeof rootReducer>;
type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export { store, persistor, RootState, AppDispatch };
